import React, { useEffect, useState } from "react";
import FormBuilderComponent from "./form_builder";
import axiosInstance from '../../../axiosInstance';
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import TextInput from "../../common/Form/textInput";
import Grid from "apollo-react/components/Grid";
import Modal from "apollo-react/components/Modal";

export default function SubFormsFormBuilder({persona}) {
  const { id } = useParams();
  const [form, setform] = useState();
  const [formCopy, setformCopy] = useState();
  const [discardModal, setDiscardModal] = useState(false);
  const [formDataFields, setFormDataFields] = useState({
    isTemplate: false,
    formFields: [],
  });
  const navigate = useNavigate();
  const getSubForm = async () => {

    await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/subforms/${id}`, { withCredentials: true })
    .then((response) => {
      console.log(response.data);

      setform({
        ...response.data,
        description: response.data.description
          ? response.data.description
          : "",
      });
      setformCopy({
        ...response.data,
        description: response.data.description
          ? response.data.description
          : "",
      });
      setFormDataFields({
        ...formDataFields,
        formFields: response.data["json_object"],
      });
    })
    .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (discardModal) {
      setFormDataFields({ ...formDataFields, isTemplate: false });
    }
  }, [discardModal]);

  const handleFormSave = async (formJsonData) => {
    try {
      //TODO to be required in the form
      if (form.name === "") {
        toast.error(t("Subform Name is required"), { position: "top-center" });
        return;
      }

      if (formJsonData.length === 2) {
        toast.error(t("Subform must contain at least one field"), {
          position: "top-center",
        });
        return;
      }


      await axiosInstance.put(`${process.env.REACT_APP_SERVER_URL}/api/subforms/${id}`,
        { ...form, json_object: formJsonData }, 
        { withCredentials: true })
        .catch((err) => console.log(err));

      toast.success(t("Form Updated Successfully!"), {
        position: "top-center",
      });
      navigate(-1);
    } catch (error) {
      console.error(t("Error saving form"), ":", error);
      alert(t("Failed to save form."));
    }
  };
  const handleFormChange = (name, value) => {
    setform({
      ...form,
      [name]: value,
    });
  };

  useEffect(() => {
    getSubForm();
    //console.log(form);
  }, []);

  useEffect(() => {}, [form]);

  const renderBasicFormInfo = () => {
    const basicFormInfo = (
      <div>
        <Field name="name">
          {({ field, meta }) => (
            <TextInput
              {...field}
              meta={meta}
              label={"Subform name"}
              value={form?.[`name`] || ""}
              onChange={(value) => handleFormChange("name", value)}
              required
              // fullWidth={false}
            />
          )}
        </Field>

        <Field name="description">
          {({ field, meta }) => (
            <TextInput
              {...field}
              meta={meta}
              label={"Subform Description"}
              value={form?.[`description`]}
              onChange={(value) => handleFormChange("description", value)}
              multiline={true}
              textareaWidth={"100%"}
            />
          )}
        </Field>
      </div>
    );
    return basicFormInfo;
  };

  return (
    form && (
      <div
        className="content"
        style={{
          border: "solid 1px #E9E9E9",
          padding: "24px",
          borderRadius: "5px",
        }}
      >
        <Grid item md={12}>
          <Formik
            initialValues={form}
            enableReinitialize={true}
            onSubmit={handleFormSave}
          >
            <Form>{renderBasicFormInfo()}</Form>
          </Formik>
        </Grid>
        <FormBuilderComponent
          formData={formDataFields.formFields}
          onFormSave={handleFormSave}
          handleDiscardModal={() => setDiscardModal(!discardModal)}
          isTemplate={formDataFields.isTemplate}
        />

        <Modal
          open={discardModal}
          message="Are you sure you want to discard your changes?"
          buttonProps={[
            {
              onClick: () => {
                setDiscardModal(false);
              },
            },
            {
              label: "Confirm",
              onClick: () => {
                setform(formCopy);
                setDiscardModal(false);
                setFormDataFields({
                  ...formDataFields,
                  formFields: form["json_object"],
                  isTemplate: true,
                });
              },
            },
          ]}
          hideHeader
          id="hideHeader"
        />
      </div>
    )
  );
}
